import { IPageLayoutType } from "../../types/pageLayoutTypes";

export const useInventoryDetails = () => {
  const rowData = [
    {
      id: "S101",
      badge: "New",
      patientid: "3333-222",
      collectionSite: "S10010",
      studyID: "ONC-NSCLC-2024-01",
      type: "Stained Slide",
      location: "Lab#987",
      isNew: true,
    },
    {
      id: "S102",
      badge: "Updated",
      patientid: "3333-222",
      collectionSite: "S10010",
      studyID: "ONC-NSCLC-2024-01",
      type: "Stained Slide",
      location: "Lab#987",
      isUpdated: true,
    },
    {
      id: "S103",
      badge: "",
      patientid: "3333-222",
      collectionSite: "S10010",
      studyID: "ONC-NSCLC-2024-01",
      type: "Stained Slide",
      location: "Lab#987",
    },
    {
      id: "S104",
      badge: "",
      patientid: "3333-222",
      collectionSite: "S10010",
      studyID: "ONC-NSCLC-2024-01",
      type: "Unstained Slide",
      location: "Lab#987",
    },
  ];
  const inventorySampleInfoContentJson: any = [
    {
      title: "",
      noCard: true,
      content: [
        {
          label: "Type",
          value: "Stained Slide",
          size: 4,
        },
        {
          label: "Tissue Type",
          value: "Stained Slide",
          size: 4,
        },
        {
          label: "Slide Type",
          value: "Uncoated",
          size: 4,
        },
        {
          label: "Procedure Type",
          value: "Excisional",
          size: 4,
        },
        {
          label: "Tissue Laterality",
          value: "Right",
          size: 4,
        },
        {
          label: "Decalcification",
          value: "Performed",
          size: 4,
        },
        {
          label: "Collection Date",
          value: "05-01-2024",
          size: 4,
        },
        {
          label: "Slide Number",
          value: "1",
          size: 4,
        },
        {
          label: "Fixation Type",
          value: " ",
          size: 4,
        },
      ],
    },
  ];
  const inventorySampleInfo2ContentJson: IPageLayoutType[] = [
    {
      title: "",
      noCard: true,
      content: [
        {
          label: "Address",
          value:
            "Number One Hospital, 230 Clinical Drive, Suite 123, New York, NY 12345",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const inventoryPatientInfoContentJson: IPageLayoutType[] = [
    {
      title: "",
      description: "",
      noCard: true,
      content: [
        {
          label: "Patient ID",
          value: "3333-222",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Name",
          value: "John Deo",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "DOB",
          value: "03-01-1966",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Gender",
          value: "M",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Address",
          value:
            "Number One Hospital, 230 Clinical Drive, Suite 123 New York, NY 12345",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Phone",
          value: "301-111-2222",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const inventoryPatientInfo2ContentJson: IPageLayoutType[] = [
    {
      title: "",
      description: "",
      noCard: true,
      content: [
        {
          label: "Clinical History",
          value: "Lung Cancer",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Treatment and Medical Record",
          value: "document.pdf",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Study",
          value: "MERKAF-AST-101",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Enrolled Date",
          value: "01-01-2024",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];
  const inventoryPatientInfo3ContentJson: IPageLayoutType[] = [
    {
      title: "",
      description: "",
      noCard: true,
      content: [
        {
          label: "Enrolled Site",
          value: "S10010",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Address",
          value:
            "Number One Hospital, 230 Clinical Drive, Suite 123 New York, NY 12345",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const inventoryParentInfoContentJson: IPageLayoutType[] = [
    {
      title: "Parent Sample Info",
      caption: "",
      description: "",
      content: [
        {
          label: "Sample ID",
          value: "B123",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Tissue Type",
          value: "Lung",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Procedure Type",
          value: "Core needle",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Collection Date",
          value: "04-01-2024",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Tissue Type",
          value: "Lung",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Tissue Larerality",
          value: "Right",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Decalcification",
          value: "Perfoemed",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Fixation Type",
          value: "04-01-2024",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const inventoryTestContentJson: IPageLayoutType[] = [
    {
      title: "Test",
      caption: "",
      description: "",
      content: [
        {
          label: "Name",
          value: "PD-L1 by clone 22C3 in Tissue by Immune stain",
          size: {
            mediumScreen: 5,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Report",
          value: "PDFlink",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Report Date",
          value: "05-01-2024",
          size: {
            mediumScreen: 3,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const totalData: any = {
    sample_type: "Stained Slide",
    tissue_type: "Stained Slide",
    slide_type: "Uncoated",
    procedure_type: "Excisional",
    tissue_laterality: "Right",
    decalcification: "Performed",
    collection_date: "05-01-2024",
    slide_number: "1",
    fixation_type: " ",
    "patient id": 3333 - 222,
    dob: "03-01-1966",
    gender: "M",
    address:
      "Number One Hospital, 230 Clinical Drive, Suite 123 New York, NY 12345",
    name: "John Deo",
    phone: "301-111-2222",
    "clinical history": "Lung Cancer",
    site_id: "S10010",
    "enrolled date": "01-01-2024",
    "enrolled study": "MERKAF-AST-101",
    "treatment and medical record": "",
    "tissue type": "lung",
    "procedure type": "Core Needle",
    "collection date": "04-01-2024",
    "tissue laterality": "Right",
  };
  return {
    rowData,
    inventorySampleInfoContentJson,
    inventorySampleInfo2ContentJson,
    inventoryPatientInfoContentJson,
    inventoryPatientInfo2ContentJson,
    inventoryPatientInfo3ContentJson,
    inventoryParentInfoContentJson,
    inventoryTestContentJson,
    totalData,
  };
};
